module.exports = __webpack_public_path__ + "img/y-2.4a44435c.jpg";